export default {
  API_BASE_URL: 'https://api.dev.' + window.BRAND_API_DOMAIN  + '/v1/',
  AUTH_BASE_URL: 'https://auth.dev.' + window.BRAND_API_DOMAIN,
  IMAGE_BASE_URL: 'https://api.dev.' + window.BRAND_API_DOMAIN + '/v1/',
  WEB_SUB_URL: '/',
  WEB_BASE_URL: 'https://console.dev.' + window.BRAND_API_DOMAIN + '/',
  MQTT_URL: 'mqtts://mqtt.dev.opsense.com',
  VERSION: '20.12.15.34-1-gec67e563',
  GA_ID: 'UA-6070396-7',
  ENVIRONMENT: 'development'
};
